/**
 * apiHelpers — intercept global fetch para agregar header X-User-Email automáticamente.
 *
 * Razón: hay 18+ llamadas a fetch dispersas en App.js + components. Monkey-patch evita
 * tocar cada una. El header se popula desde Firebase Auth currentUser.email (set por
 * AuthContext en window.__currentUserEmail).
 *
 * Limitación: si el currentUser cambia DURANTE un fetch en vuelo, el header puede
 * tener el email anterior. Es aceptable — el audit log captura el momento del request.
 *
 * Solo agrega el header si:
 *   - hay un email seteado
 *   - el request es same-origin (no agregar a APIs externas como Heroku LLM)
 */

let _userEmail = null;

export function setAuditUserEmail(email) {
  _userEmail = email || null;
}

export function getAuditUserEmail() {
  return _userEmail;
}

/**
 * Wrap global fetch. Idempotente — llamar más de una vez no apila wrappers.
 * Solo agrega header X-User-Email a requests same-origin o relativos.
 */
let _installed = false;
export function installAuditHeader() {
  if (_installed) return;
  _installed = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = function patchedFetch(input, init = {}) {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      // Same-origin o path relativo: agregar header. Externos (https://...): no.
      // En dev, frontend corre en :3000 y backend en :3101 — ambos localhost cuentan como internal.
      let isExternal = /^https?:\/\//i.test(url) && !url.startsWith(window.location.origin);
      if (isExternal) {
        try {
          const u = new URL(url);
          const here = new URL(window.location.origin);
          if ((u.hostname === 'localhost' || u.hostname === '127.0.0.1') && (here.hostname === 'localhost' || here.hostname === '127.0.0.1')) {
            isExternal = false;
          }
        } catch (_) { /* keep isExternal */ }
      }

      if (!isExternal && _userEmail) {
        const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined) || {});
        if (!headers.has('X-User-Email')) {
          headers.set('X-User-Email', _userEmail);
        }
        init = { ...init, headers };
      }
    } catch (e) {
      // No romper fetch por errores del wrapper.
      console.warn('[apiHelpers] header inject failed:', e?.message);
    }
    return originalFetch(input, init);
  };
}
